export const Text = `
<Text size="md">Text 2</Text> 
// size="sm" (Small)
// size="md" (Base) Default
// size="lg" (Large)
`
